import { WeekDaysEnum } from "@oysterhr/schema"

export const DAYS = [
  WeekDaysEnum.Monday,
  WeekDaysEnum.Tuesday,
  WeekDaysEnum.Wednesday,
  WeekDaysEnum.Thursday,
  WeekDaysEnum.Friday,
  WeekDaysEnum.Saturday,
  WeekDaysEnum.Sunday,
]
